var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('p',{staticClass:"p-small"},[_vm._v(" Copyright © 2020 "),_c('a',{attrs:{"href":_vm.companyWebsite}},[_vm._v(_vm._s(_vm.companyName))]),_vm._v(" - All rights reserved ")])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }